// extracted by mini-css-extract-plugin
module.exports = {"filtersContainer":"Results_filtersContainer__2eb5r","icon":"Results_icon__eGFGh","baseline":"Results_baseline__CUbyh","topContainer":"Results_topContainer__3fGg8"};